// Single source of truth for "where does this user's dashboard live?".
// Used by login redirect, the "/" + catch-all routes, the navbar brand/logo,
// and the navbar Dashboard link so they can never drift apart.
//
// Mirrors the access model: DIRECTOR == ADMIN. A user with a "primary" role
// (admin, intake, coordinator, navigator) plus an extra driver/mentor role
// still lands on the primary dashboard, not the driver/mentor one.
export function dashboardPathFor(user) {
  const roles = user?.roles || [];
  const hasAny = (...rs) => rs.some((r) => roles.includes(r));

  const isDriverOnly =
    roles.includes("DRIVER") &&
    !hasAny("ADMIN", "DIRECTOR", "COORDINATOR", "INTAKE_WORKER", "NAVIGATOR", "MENTOR", "VIEWER");
  const isMentorOnly =
    roles.includes("MENTOR") &&
    !hasAny("ADMIN", "DIRECTOR", "COORDINATOR", "INTAKE_WORKER", "NAVIGATOR");

  if (isDriverOnly) return "/driver-dashboard";
  if (hasAny("ADMIN", "DIRECTOR")) return "/admin-dashboard";
  if (isMentorOnly) return "/mentor-dashboard";
  // Intake workers, coordinators, navigators, viewers.
  return "/dashboard";
}
